<ng-container *ngIf="mimeType === 'application/pdf'; else otherType">
  <div class="pdf-container shimmer">
    <ng2-pdfjs-viewer #pdfViewer [pdfSrc]="encodeUrl(url)"></ng2-pdfjs-viewer>
  </div>
</ng-container>

<ng-template #otherType>
  <div class="image-container">
    <img [attr.src]="url | safe: 'url'" [alt]="name" class="image" />
  </div>
</ng-template>
